
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Quels sont ses points faibles?`}</em></p>
    <p>{`Il y a longtemps eu une certaine méfiance liée à la Russie, encore alimentée par
les fanfaronnades de Vladimir Poutine, les annonces précipitées et un manque de
transparence (les résultats du vaccin étaient annoncés uniquement dans des
communiqués).`}</p>
    <p>{`Les résultats des essais cliniques publiés dans le
`}<a parentName="p" {...{
        "href": "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(21)00191-4/fulltext"
      }}>{`"Lancet"`}</a>{`
semblent avoir convaincu. Mais depuis, ni l'Union européenne ni l'OMS ne l'ont
reconnu. En Russie également, les autorités peinent à convaincre leurs propres
citoyens à tendre le bras.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;